import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const media = (u) =>
  !u ? "" : u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`;

export const useGiveawayState = () =>
  useQuery({
    queryKey: ["giveaway-state"],
    queryFn: async () => (await api.get("/giveaway/state")).data,
    staleTime: 60000,
    retry: false,
  });
